<template>
  <div
    id="resend-mail-modal-confirm"
    class="modal"
    tabindex="-1"
    data-backdrop="static"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body p-0">
          <div class="p-5 text-center">
            <InfoIcon class="w-16 h-16 text-theme-12 mx-auto mt-3" />
            <div class="text-3xl mt-5">คุณแน่ใจ</div>
            <div class="text-gray-600 mt-2">
              ต้องการส่งเมลซ้ำรายการนี้ ใช่ หรือ ไม่?
            </div>
          </div>
          <div class="px-5 pb-8 text-center">
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-outline-secondary w-24 dark:border-dark-5 dark:text-gray-300 mr-1"
            >
              ไม่
            </button>
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-warning w-24"
              @click="confirmResend()"
            >
              ใช่
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useStore } from '@/store'
import alert from '@/helpers/alert'
import { api } from '../utils/api'
export default defineComponent({
  name: 'modalResendEmail',
  props: {
    module: {
      type: String,
      required: true
    },
    docType: {
      type: String,
      required: true
    },
    docId: {
      type: Number
    }
  },
  setup(props) {
    const store = useStore()

    const confirmResend = async () => {
      store.commit('global/setBtnActiveFix', {
        type: 'btnResend',
        status: true
      })
      const data = {
        module: props.module,
        doc_type: props.docType,
        doc_id: props.docId
      }
      await api
        .post(
          `${process.env.VUE_APP_API_BROADCAST}/notification/sendEmail`,
          data
        )
        .then(res => {
          if (res.code == 200) {
            alert.success()
          } else {
            alert.error(res.message)
          }
          store.commit('global/setBtnActiveFix', {
            type: 'btnResend',
            status: false
          })
        })
        .catch(e => {
          store.commit('global/setBtnActiveFix', {
            type: 'btnResend',
            status: false
          })
          alert.error(e.message)
        })
    }
    return {
      confirmResend
    }
  }
})
</script>
